import { Component, Input } from '@angular/core';
import { User } from "../../../app/app.interfaces";
import { FormGroup } from "@angular/forms";

@Component({
	selector: 'admin-user',
	templateUrl: 'admin-user.html'
})


export class AdminUser {

	@Input() user: User;
	form: FormGroup;
	edit: boolean = false;

	
	
	updateUser(user): void {
		this.user = user;
		this.edit = false;

	}
}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-user/admin-user.ts